import EmbedZapier from 'app/developer-v3/pages/embed/zapier';

import { getAppUrl } from 'app/developer-v3/utils/url';

export default {
  routes: {
    '.': EmbedZapier,
    'zap-editor': {
      onEnter({ routeTo, router }) {
        routeTo(`${getAppUrl(router.next.params.id)}/embed-zap-editor`);
      },
    },
    'zap-prefill-generator': {
      onEnter({ routeTo, router }) {
        routeTo(`${getAppUrl(router.next.params.id)}/prefilled-zaps`);
      },
    },
    'workflow-element': {
      onEnter({ routeTo, router }) {
        routeTo(`${getAppUrl(router.next.params.id)}/workflow-element`);
      },
    },
    'workflow-api': {
      onEnter({ routeTo, router }) {
        routeTo(`${getAppUrl(router.next.params.id)}/workflow-api`);
      },
    },
    'automatic-account-creation': {
      onEnter({ routeTo, router }) {
        routeTo(
          `${getAppUrl(router.next.params.id)}/automatic-account-creation`
        );
      },
    },
    settings: {
      routes: {
        '.': {
          onEnter({ routeTo, router }) {
            routeTo(`${getAppUrl(router.next.params.id)}/embed-settings`);
          },
        },
        client: {
          onEnter({ routeTo, router }) {
            routeTo(
              `${getAppUrl(router.next.params.id)}/embed-settings/credentials`
            );
          },
        },
        credentials: {
          onEnter({ routeTo, router }) {
            routeTo(
              `${getAppUrl(router.next.params.id)}/embed-settings/credentials`
            );
          },
        },
        domains: {
          onEnter({ routeTo, router }) {
            routeTo(
              `${getAppUrl(router.next.params.id)}/embed-settings/domains`
            );
          },
        },
        redirects: {
          onEnter({ routeTo, router }) {
            routeTo(
              `${getAppUrl(router.next.params.id)}/embed-settings/redirects`
            );
          },
        },
      },
    },
  },
};
